
import { Component, Vue, Prop} from 'vue-property-decorator';
import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";

import RelocChildrenInfo from "./childInfo/RelocChildrenInfo.vue";
import RelocationOfChildBestInterestsOfChild from "./RelocationOfChildBestInterestsOfChild.vue";
import RelocationOfChildQuestionnaire from "./RelocationOfChildQuestionnaire.vue";
import ReviewYourAnswersReloc from "./reviewRELOC/ReviewYourAnswersRELOC.vue";
import PreviewFormsReloc from "./reviewRELOC/PreviewFormsRELOC.vue";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        StepBase,
        RelocationOfChildQuestionnaire,
        RelocationOfChildBestInterestsOfChild,
        RelocChildrenInfo,
        ReviewYourAnswersReloc,
        PreviewFormsReloc
    }
})
export default class ChildRelocationStep extends Vue {

  @Prop({required: true})
  step!: stepInfoType;

  @applicationState.State
  public stPgNo!: stepsAndPagesNumberInfoType;

  
}
